import tw from 'tailwind.macro'
import styled from 'styled-components'

const Inner = styled.div`
  ${tw`w-5/5 lg:w-4/5 text-center lg:text-left`};margin-top:0px;
`

export default Inner
